export default __webpack_public_path__ + "static/media/contact.5d54cc75.png";